/* eslint-disable @typescript-eslint/explicit-function-return-type */
import { UntypedFormGroup, Validators, UntypedFormControl } from '@angular/forms';
import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { CompanyService } from '../services/company.service';
import { ToastService } from 'src/app/shared/services/toast.service';
import { ActivatedRoute, Router } from '@angular/router';
import { ECompanyTabsEdit } from '../data/company-tabs-edit.enum';
import { DoctorService } from '../../doctors/services/doctor.service';
import { EOrdenacao } from 'src/app/shared/data/ordenacao.enum';
import { IListByFilterMedico, IMedico } from '../../doctors/models/doctor';
import { UsuarioAdminService } from '../../usuarios-admin/services/usuario-admin.service';
import { IFiltroListagemUsuarioAdmin, IUsuarioAdmin } from '../../usuarios-admin/data/usuario-admin';
import { IFilial, IListByFilterFiliais } from '../../filiais/data/filiais';
import { FiliaisService } from '../../filiais/services/filiais.service';
import { switchMap } from 'rxjs/operators';
import { EMPTY, Observable } from 'rxjs';
import { ResponseDefault } from 'src/app/shared/data/response-default.interface';
import { ICadastroEmployee, IListByFilterEmployee } from '../../employee/employee/models/employee';
import { EmployeeService } from '../../employee/employee/services/employee.service';
import { SessionService } from 'src/app/shared/services/session.service';
import { ListFilialService } from '../../centro-de-custos/services/list-filial.service';
import { ListCetroCustoService } from '../../employee/employee/services/list-centro-custo.service';
import { IListCentroCusto } from '../../employee/employee/models/list-centro-custo';
import { IFilialCompany } from '../../filiais/data/listcompany';
import { ICadastroCentroCusto, IListByFilterCentroCusto } from '../../centro-de-custos/models/centrocusto';
import { CentroCustosService } from '../../centro-de-custos/services/centro-custos.service';
import { ERoleAdminString } from 'src/app/shared/data/role.enum';
import { PartnerService } from '../../partners/services/partner.service';
import { IPartner, IListByFilterParceiros } from '../../partners/models/partner.interface';

@Component({
  selector: 'app-edit-company',
  templateUrl: './edit-company.component.html',
  styleUrls: ['./edit-company.component.scss']
})
export class EditCompanyComponent implements OnInit {
  formCompany = new UntypedFormGroup({
    active: new UntypedFormControl('', [Validators.required]),
    type: new UntypedFormControl('', [Validators.required]),
    name: new UntypedFormControl('', [Validators.required]),
    trading: new UntypedFormControl(''),
    document: new UntypedFormControl('', [Validators.required]),
    code: new UntypedFormControl(''),
    email: new UntypedFormControl('', [Validators.required, Validators.email]),
    phone: new UntypedFormControl('', [Validators.required]),
    id: new UntypedFormControl(''),
    partnerId: new UntypedFormControl(''),
    logo: new UntypedFormControl(null)
  });
  ERoleAdminString = ERoleAdminString;
  opcoesFiliais: IFilialCompany[] = [];
  opcoesCentroCustos: IListCentroCusto[] = [];
  companyLogo?: string | null;
  imageFile?: { link: string; file: any; name: string; base64: string };
  ECompanyTabsEdit = ECompanyTabsEdit;
  tabSelecionada: ECompanyTabsEdit = ECompanyTabsEdit.DadosEmpresa;
  companyId?: string;
  ordenarControl = new UntypedFormControl(1);
  employers: ICadastroEmployee[] = [];
  dadosPaginacaoColaborador = {
    ordenacao: EOrdenacao.AlfabeticaAZ,
    paginaSelecionada: 0,
    tamanhoPagina: 4,
    totalPaginas: 0,
    itensTotal: 0
  };

  doctors: IMedico[] = [];
  dadosPaginacaoMedicos = {
    ordenacao: EOrdenacao.AlfabeticaAZ,
    paginaSelecionada: 0,
    tamanhoPagina: 4,
    totalPaginas: 0,
    itensTotal: 0
  };

  usuariosAdmin: IUsuarioAdmin[] = [];
  dadosPaginacaoUsuariosAdmin = {
    ordenacao: EOrdenacao.AlfabeticaAZ,
    paginaSelecionada: 0,
    tamanhoPagina: 4,
    totalPaginas: 0,
    itensTotal: 0
  };

  atendentes: IUsuarioAdmin[] = [];
  dadosPaginacaoAtendentes = {
    ordenacao: EOrdenacao.AlfabeticaAZ,
    paginaSelecionada: 0,
    tamanhoPagina: 4,
    totalPaginas: 0,
    itensTotal: 0
  };

  filiais: IFilial[] = [];
  dadosPaginacaoFiliais = {
    ordenacao: EOrdenacao.AlfabeticaAZ,
    paginaSelecionada: 0,
    tamanhoPagina: 4,
    totalPaginas: 0,
    itensTotal: 0
  };

  centros: ICadastroCentroCusto[] = [];
  dadosPaginacaoCentroDeCusto = {
    ordenacao: EOrdenacao.AlfabeticaAZ,
    paginaSelecionada: 0,
    tamanhoPagina: 4,
    totalPaginas: 0,
    itensTotal: 0
  };

  partners: IPartner[] = [];

  constructor(
    private readonly companyService: CompanyService,
    private readonly toastService: ToastService,
    private readonly activatedRoute: ActivatedRoute,
    private readonly router: Router,
    private readonly cdr: ChangeDetectorRef,
    private readonly doctorservice: DoctorService,
    private readonly usuariosAdminService: UsuarioAdminService,
    private readonly filiaisService: FiliaisService,
    private readonly employeeService: EmployeeService,
    private readonly sessionService: SessionService,
    private readonly listCentroCustoService: ListCetroCustoService,
    private readonly listFilialService: ListFilialService,
    private readonly centroCustoService: CentroCustosService,
    private readonly partnerService: PartnerService
  ) { }

  public ngOnInit(): void {
    //this.companyId = this.sessionService.getSession().companyId;
    this.companyId = this.activatedRoute.snapshot.paramMap.get('id')!;
    const role = this.sessionService.getSession().role
    // this.getListFilial(this.companyId);
    // this.getListCentroCusto(this.companyId);

    if (this.companyId) {
      this.carregarDetalhesEmpresa(this.companyId);

      if (role === ERoleAdminString.Admin) {
        this.carregarMedicos();
      }
      this.carregarUsuariosAdmin();
      this.carregarFiliais();
      this.carregarColaboradores();
      this.carregarCentroDeCustos();
      this.carregarParceiros();
    }
  }

  carregarParceiros(): void {
    const filtros: IListByFilterParceiros = {
      orderBy: Number(EOrdenacao.AlfabeticaAZ),
      pageNumber: 0,
      pageSize: 9999
    };

    const partnerId = this.sessionService.getSession().partnerId;
    const companyId = this.sessionService.getSession().companyId;
    const accountRole = this.sessionService.getSession().accountRole;

    if (partnerId) {
      filtros.partnerId = partnerId;
    }

    if (companyId) {
      filtros.companyId = companyId;
    }

    if (accountRole) {
      filtros.accountRole = parseInt(accountRole);
    }

    this.partnerService.listarTodosParceiros(filtros).subscribe((resposta) => {
      this.partners = resposta.data;
    });
  }

  public carregarDetalhesEmpresa(companyId: string): void {
    this.formCompany.get('id')!.patchValue(companyId);

    this.companyService.detalhesEmpresa(companyId).subscribe((resposta) => {
      if (resposta.messages && resposta.messages.length > 0) {
        this.toastService.toast(resposta.messages);
      }

      if (resposta.isSucceed) {
        this.formCompany.get('type')!.patchValue(resposta.data.type);
        this.formCompany.get('name')!.patchValue(resposta.data.name);
        this.formCompany.get('trading')!.patchValue(resposta.data.trading);
        this.formCompany.get('document')!.patchValue(resposta.data.document);
        this.formCompany.get('code')!.patchValue(resposta.data.code);
        this.formCompany.get('email')!.patchValue(resposta.data.email);
        this.formCompany.get('phone')!.patchValue(resposta.data.phone);
        this.formCompany.get('active')!.patchValue(resposta.data.active);
        this.formCompany.get('partnerId')!.patchValue(resposta.data.partnerId);
        this.companyLogo = resposta.data.logo;
      }
    });
  }

  public editarEmpresa(): void {
    if (this.formCompany.valid) {
      this.companyService
        .editarEmpresa({ ...this.formCompany.getRawValue(), logo: this.companyLogo })
        .subscribe((resposta) => {
          if (resposta.messages && resposta.messages.length > 0) {
            this.toastService.toast(resposta.messages);
          }

          //MAYBE: possivel call para AWS s3 no futuro
          // if (resposta.isSucceed && this.imageFile) {
          //   return this.salvarImagem();
          // }

          this.router.navigateByUrl('/dash/empresas');
        });
    }
  }

  //MAYBE: provavelmente será alterado para enviar a imagem ao bucket AWS
  public salvarImagem(): Observable<ResponseDefault<boolean>> {
    const imagemFormData = new FormData();

    imagemFormData.append('id', String(this.companyId));
    imagemFormData.append('image', this.imageFile!.file);

    return this.companyService.adicionarImagemEmpresa(imagemFormData);
  }

  public mudarTabSelecionada(tabSelecionada: ECompanyTabsEdit): void {
    this.tabSelecionada = tabSelecionada;
  }

  public onImageInput(evento: Event): void {
    const { files } = evento.target as HTMLInputElement;

    if (files && files.length > 0) {
      const reader = new FileReader();

      reader.readAsDataURL(files[0]);

      reader.onload = (_event: any) => {
        this.imageFile = {
          link: _event.target.result,
          file: files[0],
          name: files[0].name,
          base64: reader.result!.toString().split(',')[1]
        };

        this.companyLogo = this.imageFile.base64;

        this.cdr.markForCheck();
      };
    }
  }

  public carregarMedicos(): void {
    const filtros: IListByFilterMedico = {
      orderBy: Number(this.dadosPaginacaoMedicos.ordenacao),
      pageNumber: Number(this.dadosPaginacaoMedicos.paginaSelecionada),
      pageSize: Number(this.dadosPaginacaoMedicos.tamanhoPagina)
    };

    const partnerId = this.sessionService.getSession().partnerId;
    const companyId = this.sessionService.getSession().companyId;
    const accountRole = this.sessionService.getSession().accountRole;

    if (partnerId) {
      filtros.partnerId = partnerId;
    }

    if (companyId) {
      filtros.companyId = companyId;
    }

    if (accountRole) {
      filtros.accountRole = parseInt(accountRole);
    }

    this.doctorservice.listarTodosMedicos(filtros).subscribe((res) => {
      this.doctors = res.data;
      this.dadosPaginacaoMedicos.totalPaginas = Math.ceil(res.count! / this.dadosPaginacaoMedicos.tamanhoPagina);
      this.dadosPaginacaoMedicos.itensTotal = res.count!;
    });
  }

  public mudouPaginaMedico(paginaSelecionada: number): void {
    this.dadosPaginacaoMedicos.paginaSelecionada = paginaSelecionada;

    this.carregarMedicos();
  }

  public mudouTamanhoPaginaMedico(itensPaginaSelecionada: number): void {
    this.dadosPaginacaoMedicos.tamanhoPagina = itensPaginaSelecionada;
    this.dadosPaginacaoMedicos.paginaSelecionada = 0;

    this.carregarMedicos();
  }

  public carregarCentroDeCustos(): void {
    const filtros: IListByFilterCentroCusto = {
      orderBy: Number(this.dadosPaginacaoCentroDeCusto.ordenacao),
      pageNumber: Number(this.dadosPaginacaoCentroDeCusto.paginaSelecionada),
      pageSize: Number(this.dadosPaginacaoCentroDeCusto.tamanhoPagina)
    };

    const partnerId = this.sessionService.getSession().partnerId;
    const companyId = this.sessionService.getSession().companyId;
    const accountRole = this.sessionService.getSession().accountRole;

    if (partnerId) {
      filtros.partnerId = partnerId;
    }

    if (companyId) {
      filtros.companyId = companyId;
    }

    if (accountRole) {
      filtros.accountRole = parseInt(accountRole);
    }

    this.centroCustoService.listarTodosCentrosCusto(filtros).subscribe((res) => {
      this.centros = res.data;
      this.dadosPaginacaoCentroDeCusto.totalPaginas = Math.ceil(
        res.count! / this.dadosPaginacaoCentroDeCusto.tamanhoPagina
      );
      this.dadosPaginacaoCentroDeCusto.itensTotal = res.count!;
    });
  }

  public mudouPaginaCentroDeCusto(paginaSelecionada: number): void {
    this.dadosPaginacaoCentroDeCusto.paginaSelecionada = paginaSelecionada;

    this.carregarCentroDeCustos();
  }

  public mudouTamanhoPaginaCentroDeCusto(itensPaginaSelecionada: number): void {
    this.dadosPaginacaoCentroDeCusto.tamanhoPagina = itensPaginaSelecionada;
    this.dadosPaginacaoCentroDeCusto.paginaSelecionada = 0;

    this.carregarCentroDeCustos();
  }

  public carregarUsuariosAdmin(): void {
    const filtros: IFiltroListagemUsuarioAdmin = {
      orderBy: Number(this.dadosPaginacaoUsuariosAdmin.ordenacao),
      pageNumber: Number(this.dadosPaginacaoUsuariosAdmin.paginaSelecionada),
      pageSize: Number(this.dadosPaginacaoUsuariosAdmin.tamanhoPagina)
    };

    const partnerId = this.sessionService.getSession().partnerId;
    const companyId = this.sessionService.getSession().companyId;
    const accountRole = this.sessionService.getSession().accountRole;

    if (partnerId) {
      filtros.partnerId = partnerId;
    }

    if (companyId) {
      filtros.companyId = companyId;
    }

    if (accountRole) {
      filtros.accountRole = parseInt(accountRole);
    }

    this.usuariosAdminService.listarTodosUsuariosAdmin(filtros).subscribe((res) => {
      this.usuariosAdmin = res.data;
      this.dadosPaginacaoUsuariosAdmin.totalPaginas = Math.ceil(
        res.count! / this.dadosPaginacaoUsuariosAdmin.tamanhoPagina
      );
      this.dadosPaginacaoUsuariosAdmin.itensTotal = res.count!;
    });
  }

  public mudouPaginaUsuariosAdmin(paginaSelecionada: number): void {
    this.dadosPaginacaoUsuariosAdmin.paginaSelecionada = paginaSelecionada;

    this.carregarUsuariosAdmin();
  }

  public mudouTamanhoPaginaUsuariosAdmin(itensPaginaSelecionada: number): void {
    this.dadosPaginacaoUsuariosAdmin.tamanhoPagina = itensPaginaSelecionada;

    this.carregarUsuariosAdmin();
  }

  public carregarColaboradores(): void {
    const filtros: IListByFilterEmployee = {
      orderBy: Number(this.dadosPaginacaoColaborador.ordenacao),
      pageNumber: Number(this.dadosPaginacaoColaborador.paginaSelecionada),
      pageSize: Number(this.dadosPaginacaoColaborador.tamanhoPagina)
    };

    const partnerId = this.sessionService.getSession().partnerId;
    const companyId = this.sessionService.getSession().companyId;
    const accountRole = this.sessionService.getSession().accountRole;

    if (partnerId) {
      filtros.partnerId = partnerId;
    }

    if (companyId) {
      filtros.companyId = companyId;
    }

    if (accountRole) {
      filtros.accountRole = parseInt(accountRole);
    }

    this.employeeService.listarTodosColaboradores(filtros).subscribe((res) => {
      this.employers = res.data;
      this.dadosPaginacaoColaborador.totalPaginas = Math.ceil(
        res.count! / this.dadosPaginacaoColaborador.tamanhoPagina
      );
      this.dadosPaginacaoColaborador.itensTotal = res.count!;
    });
  }

  public mudouPaginaColaborador(paginaSelecionada: number): void {
    this.dadosPaginacaoColaborador.paginaSelecionada = paginaSelecionada;

    this.carregarColaboradores();
  }

  public mudouTamanhoPaginaColaborador(itensPaginaSelecionada: number): void {
    this.dadosPaginacaoColaborador.tamanhoPagina = itensPaginaSelecionada;
    this.dadosPaginacaoColaborador.paginaSelecionada = 0;

    this.carregarColaboradores();
  }

  public carregarFiliais(): void {
    const filtros: IListByFilterFiliais = {
      orderBy: Number(this.dadosPaginacaoFiliais.ordenacao),
      pageNumber: Number(this.dadosPaginacaoFiliais.paginaSelecionada),
      pageSize: Number(this.dadosPaginacaoFiliais.tamanhoPagina)
    };

    const partnerId = this.sessionService.getSession().partnerId;
    const companyId = this.sessionService.getSession().companyId;
    const accountRole = this.sessionService.getSession().accountRole;

    if (partnerId) {
      filtros.partnerId = partnerId;
    }

    if (companyId) {
      filtros.companyId = companyId;
    }

    if (accountRole) {
      filtros.accountRole = parseInt(accountRole);
    }

    this.filiaisService.listarTodasFiliais(filtros).subscribe((res) => {
      this.filiais = res.data;
      this.dadosPaginacaoFiliais.totalPaginas = Math.ceil(res.count! / this.dadosPaginacaoFiliais.tamanhoPagina);
      this.dadosPaginacaoFiliais.itensTotal = res.count!;
    });
  }

  public mudouPaginaFilial(paginaSelecionada: number): void {
    this.dadosPaginacaoFiliais.paginaSelecionada = paginaSelecionada;

    this.carregarFiliais();
  }

  public mudouTamanhoPaginaFilial(itensPaginaSelecionada: number): void {
    this.dadosPaginacaoFiliais.tamanhoPagina = itensPaginaSelecionada;

    this.carregarFiliais();
  }
  getListFilial(companyId?: string): void {
    this.listFilialService.getFilial(companyId).subscribe((resposta) => {
      this.opcoesFiliais = resposta.data;
    });
  }
  getListCentroCusto(companyId?: string): void {
    this.listCentroCustoService.getCentroCusto(companyId).subscribe((resposta) => {
      this.opcoesCentroCustos = resposta.data;
    });
  }
}
